module.exports = __webpack_public_path__ + "static/img/login_img.ac3311f5.png";